import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'

import { Action, CountryCodes, Resource } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { CheckAccessDirective } from '@ti/core/common/directives'
import { injectDestroy$, selectState } from '@ti/core/common/utils'
import { CONFIG } from '@ti/core/contracts/config'
import { PlusIconComponent } from '@ti/core/icons/plus'
import { UsersIconComponent } from '@ti/core/icons/users'
import { FleetHeaderComponent } from '@ti/core/ui-kit/layout/components/fleet-header'
import {
  UserAddDialogComponent,
  UserEditDialogComponent,
  UserFormMode,
  UsersGridComponent,
} from '@ti/shared/user'

import { AdminUsersModel, provideAdminUsersModel } from '../models/users.model'

@Component({
  selector: 'app-ti-admin-users-page',
  templateUrl: 'users-page.component.html',
  styleUrls: ['users-page.component.scss'],
  providers: [provideAdminUsersModel()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FleetHeaderComponent,
    UsersIconComponent,
    CheckAccessDirective,
    Button,
    TranslatePipe,
    AsyncPipe,
    PlusIconComponent,
    UsersGridComponent,
    UserEditDialogComponent,
    UserAddDialogComponent,
  ],
})
export class AdminUsersPageComponent {
  protected readonly api = inject(ApiService)
  protected readonly config = inject(CONFIG)
  protected readonly model = inject(AdminUsersModel)
  protected readonly state = selectState(AdminUsersModel)
  protected readonly destroy$ = injectDestroy$()

  protected readonly Resource = Resource
  protected readonly Action = Action
  protected readonly CountryCodes = CountryCodes

  protected readonly TYPES = { CountryCodes, UserFormMode }
}
